<template>
    <div class="aba-cliente">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <!-- CAIXA DE BUSCA DE LOGS -->
                <div class="column is-8">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-logs-integracao"
                    />
                </div>
                <!-- BOTÃO DE DELETAR LOGS -->
                <div
                    class="column is-4"
                    v-if="permissao.create"
                >
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="promptConfirmacaoDeletar()"
                    >
                        {{ $t("deletar-logs-cliente") }}
                    </button>
                </div>
            </div>
            <!-- LISTAGEM DOS LOGS -->
            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="logintegracaocliente"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label=" $t(f.key)"
                        :width="f.width"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'codigo'">
                            {{ props.row[f.key] }}
                        </div>
                        <div v-else-if="f.key == 'acao'">
                            {{ getAcao(props.row[f.key]) }}
                        </div>
                        <div v-else-if="f.key == 'data-hora'">
                            {{
                                props.row[f.key]
                                    ? $moment(
                                            props.row[f.key]
                                        ).format("L LT")
                                    : "—"
                            }}
                        </div>
                        <!-- MOSTAR OU ESCONDER O TEXTO EM MENSAGEM DE ERRO -->
                        <div v-else-if="f.key == 'mensagem'">
                            <span v-if="props.row[f.key].length < cutIn">{{ props.row[f.key] }}</span>
                            <b-collapse :open="false" position="is-bottom" aria-id="mensagem" v-else-if="props.row[f.key].length >= cutIn">
                                <template #trigger="showText">
                                    <span v-if="!showText.open"><small>{{ verifyText(props.row[f.key]) }}</small></span>
                                    <a aria-controls="mensagem">
                                        <small>{{ !showText.open ? $t("mostrar") : $t("esconder") }}</small>
                                    </a>
                                </template>
                                <p class="force-break"><small>{{ props.row[f.key] }}</small></p>
                            </b-collapse>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <!-- PAGINAÇÃO -->
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
    </div>
</template>
<script>

// SERVICES
import LogIntegracaoService from "@/services/LogIntegracaoService";

// COMPONENTS
import ContainerLoader from "@/components/content/loader/ContainerLoader";

/*
    @86384 - Logs de integracao com o ERP deve mostrar as informacoes conforme o que estiver
    apresentado no registro_enviado (Status) para o usuario saber o que aconteceu com a requisicao
    feita no status do cliente ao ERP
*/
export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            logintegracaocliente: [],
            fields: [
                { key: "codigo", sortable: false, sortFn: null },
                { key: "acao", width: 140, sortable: true, sortFn: null },
                { key: "data-hora", width: 180, sortable: true, sortFn: null },
                { key: "mensagem", sortable: true, sortFn: null },
            ],
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            service: new LogIntegracaoService(
                this.$http,
                this.$router
            ),
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: "",
            column: "mensagem",
            order: "asc",
            isSaving: false,
            delete: null,
            cutIn: 40,
            isDeleting: false,

            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];        

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas', 
                'clientes', 
                'ven-cliente-dados-cadastrais-cli-logintegracao')
        }else if(this.isAgro){
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess(
                'agro', 
                'clientes', 
                'agro-cliente-dados-cadastrais-cli-logintegracao');
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "clientes" },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-cli-logintegracao-" + numberId;
        },
        verifyText(str){
            if(str.length>this.cutIn) str = str.substring(0,this.cutIn)+'...';
            return str;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.getLogIntegracaoByEntidade(
                    "CLIENTE",
                    this.$route.params.id,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.column,
                    this.order,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.logintegracaocliente = value;
                    this.isEmpty = this.logintegracaocliente.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os logs de integração do cliente.");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        getLogIntegracaoByEntidade(entidade, idregistro, page = 0, limit = 15, column, order, ...params) {
            if(this.isVenda) {
                return this.service
                .getLogIntegracaoByEntidadeVendas(
                    entidade, idregistro, page, limit, column, order, ...params
                );
            }else {
                return this.service
                .getLogIntegracaoByEntidadeAgro(
                    entidade, idregistro, page, limit, column, order, ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    "codigo": m.id,
                    "acao": m.acao,
                    "data-hora": m.datahora,
                    "mensagem": m.mensagemErro,
                };
            });
        },
        getAcao(acao) {
            switch (acao) {
                case "I":
                    return this.$t("insercao");
                case "U":
                    return this.$t("atualizacao");
                case "D":
                    return this.$t("delecao");
                default:
                    return this.$t("sem-acao"); // caso log não tenha uma acao, exibe Sem Acao
            }
        },
        promptConfirmacaoDeletar() {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-deletar"),
                onConfirm: (_) => {
                    this.deletarLogs();
                },
            });
        },
        deletarLogs(){
            this.isDeleting = true;
            this.isLoading = true;

            this.deleteLog(
                    "CLIENTE",
                    this.$route.params.id
                )
                .then((value) => {
                    if (value.message == null) {
                        this.$root.showMessage("success", "msg-delete-log", true);
                        this.carregarDados();
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage("alert", value.message, true);
                        } else {
                            this.$root.showMessage(
                                "error",
                                "msg-problema-realizar-acao",
                                true
                            );
                        }
                    }
                })
                .catch((e) => {
                    console.error("Erro ao deletar os logs de integracao do cliente: " + e);
                    this.$root.showMessage(
                        "error",
                        "msg-erro-deletar",
                        true
                    );
                })
                .finally(() => {
                    this.isDeleting = false;
                    this.isLoading = false;
                });
        },
        deleteLog(entidade, idregistro) {
            if (this.isVenda) return this.service.deleteVendas(entidade, idregistro);
            else return this.service.deleteAgro(entidade, idregistro);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .botao-acao {
            margin-top: 0;
        }
    }
}
.force-break{
    white-space: pre-wrap;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
}
</style>